import { extensions } from '../extensions/Extensions.mjs';
import { ResizePlugin } from './ResizePlugin.mjs';
import { TickerPlugin } from './TickerPlugin.mjs';

"use strict";
extensions.add(ResizePlugin);
extensions.add(TickerPlugin);
//# sourceMappingURL=init.mjs.map
